import Vue from 'vue';
import Vuex, { Module } from 'vuex';

import EnumState from './enumState';
import { RootState } from '@/store/rootState';
import { ActivityDefinitionType } from '@/models/enums';
Vue.use(Vuex);

export const enumStore: Module<EnumState, RootState> = {
  namespaced: true,
  state: new EnumState(),
  mutations: {
    updateActivityDefinitionTypes(state: EnumState, activityDefinitionTypes: ActivityDefinitionType[]): void {
      state.activityDefinitionTypes = activityDefinitionTypes;
    },
  },
  actions: {},
  getters: {
    activityDefinitionTypes: (state: EnumState): ActivityDefinitionType[] | undefined => {
      return state.activityDefinitionTypes;
    },
  },
};
